export const CUSTOM_PAGE_URL = 'custom-pages';